import { Libraries } from '@react-google-maps/api';

export enum TYPES_REGIONS {
  REGION = '(regions)',
  ADRESS = 'address'
}

// Keep that constant outside of GoogleMapsScript to avoid performance issues (unintentional reload)
export const LIBRARIES: Libraries = ['geometry', 'places'];
